const FEATURES = {
  hideFunding: 'growth_hideFunding',
  instantCardProvisioningV2: 'instantCardProvisioningV2',
  minimumWalletLoad: 'minimumWalletLoad',
  globalHoldout: 'globalHoldout',
  facebookPixel: 'facebookPixel',
  plaidOAuthManualOverride: 'growth_plaidOAuthManualOverride',
  plaidOAuthAndroidLink: 'growth_plaidOAuthAndroidLink',
  nativePlaidFlow: 'growth_nativePlaidFlow',
  accessManagementEnabled: 'growth_accessManagement',
  promoCodeVerificationEnabled: 'growth_promoCodeVerification',
  userFlow: 'userFlow',
  emailErrorStateOnBlur: 'growth_emailErrorStateOnBlur',
  planChangesTermsAndConditions: 'growth_planChangesTermsAndConditions',
  proveMobileAuthEnabled: 'growth_proveMobileAuthEnabled',
  creditWaitlist: 'growth_creditWaitlist',
  requireTokenForApprovers: 'growth_requireTokenForApprovers',
  preferNotToSayOptionEnabled: 'acquisitionfire_childRegPronoun_preferNotToSay',
  smsNotificationsEnabled: 'acquisitionice_smsNotifications',
  enhancedDebitEnabled: 'acquisitionfire_enhancedDebit',
  newDeactivatedErrorMsgEnabled:
    'acquisitionfire_newDeactivatedErrorMessageEnabled',
  unauthorizedCleanStateEnabled: 'acquisitionfire_unauthorizedCleanState',
  planFlow: 'acquisitionfire_planFlow',
  modularReduxEnabled: 'acquisitionfire_modularReduxEnabled'
};

const MINIMUM_WALLET_LOAD = {
  experimentName: '10minimumWalletLoad_test',
  experimentOnVariant: 'variation_1',
  experimentOffVariant: 'control',
  minimumAmountKey: 'minimumAmount',
  defaultMinimumAmount: 20.0,
  displayMinimumAmountKey: 'displayMinimumAmount',
  defaultDisplayMinimumAmount: 20.0
};

const FLOW_8 = {
  experimentName: 'parent_flow_8',
  experimentOnVariant: 'variation_1'
};

const FLOW_10 = {
  experimentName: 'parent_flow_10',
  experimentOnVariant: 'variation_1'
};

const EMAIL_ERROR = {
  experimentName: 'growth_emailErrorStateOnBlur_test',
  experimentOffVariant: 'control'
};

const PLAN_CHANGES_TERMS_AND_CONDITIONS = {
  experimentName: 'growth_planChangesTermsAndConditions_test',
  experimentOffVariant: 'control'
};

const PROVE_MOBILE_AUTH_ENABLED = {
  experimentName: 'growth_proveMobileAuthEnabled_test',
  experimentOffVariant: 'control'
};

const CREDIT_WAITLIST = {
  experimentName: 'growth_creditWaitlist_test',
  experimentOffVariant: 'control',
  showConfirmScreenKey: 'showConfirmScreen',
  showConfirmScreenDefault: true
};

const PREFER_NOT_TO_SAY_OPTION_ENABLED = {
  experimentName: 'acquisitionfire_childRegPronoun_preferNotToSay_test',
  experimentOffVariant: 'control'
};

const SMS_NOTIFICATIONS_ENABLED = {
  experimentName: 'acquisitionice_smsNotifications_test',
  experimentOffVariant: 'control'
};

const ENHANCED_DEBIT = {
  experimentName: 'acquisitionfire_enhancedDebit_test',
  experimentOffVariant: 'control',
  experimentOnVariant: 'variation_1',
  applePayEnabledKey: 'applePay',
  googlePayEnabledKey: 'googlePay',
  threeDSEnabledKey: '3ds',
  paypalEnabledKey: 'paypal',
  venmoEnabledKey: 'venmo'
};

const DEFAULT_FEATURES = {
  [FEATURES.hideFunding]: false,
  [FEATURES.instantCardProvisioningV2]: true,
  [FEATURES.minimumWalletLoad]: false,
  [FEATURES.globalHoldout]: false,
  [FEATURES.facebookPixel]: true,
  [FEATURES.emailErrorStateOnBlur]: false,
  [FEATURES.planChangesTermsAndConditions]: false,
  [FEATURES.creditWaitlist]: false,
  [FEATURES.preferNotToSayOptionEnabled]: false,
  [FEATURES.smsNotificationsEnabled]: false,
  [FEATURES.newDeactivatedErrorMsgEnabled]: false,
  [FEATURES.enhancedDebitEnabled]: false
};

export const MAYBE_LATER = 'Maybe later';
export const NO_PERKS = `No thanks, I don't need the perks.`;

export const PROMO_CODE_STATE = {
  redeemed: 'REDEEMED',
  earned: 'EARNED'
};

export default {
  FEATURES,
  FLOW_8,
  MINIMUM_WALLET_LOAD,
  DEFAULT_FEATURES,
  FLOW_10,
  PROMO_CODE_STATE,
  EMAIL_ERROR,
  PLAN_CHANGES_TERMS_AND_CONDITIONS,
  PROVE_MOBILE_AUTH_ENABLED,
  CREDIT_WAITLIST,
  PREFER_NOT_TO_SAY_OPTION_ENABLED,
  SMS_NOTIFICATIONS_ENABLED,
  ENHANCED_DEBIT
};
